import './mobile_header.less';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { slide as BurgerMenu } from 'react-burger-menu';
import classNames from 'classnames';
import isNil from 'lodash/isNil';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import { 
  SecondaryLogo, 
  SocialLinks 
} from '../sub_components';

import { getRouter } from 'zoomforth_codesbane_viewer/lib/global_store.js';
import Button from 'zoomforth_component_lib/btn_basic.jsx';
import InPageSearchOpener from 'zoomforth_codesbane_viewer/viewer/in_page_search_display/in_page_search_opener.jsx';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';
import { isSubmenuItemSelected } from 'zoomforth_codesbane_viewer/viewer/utils/index.js';
import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';
import { executeMatchedRouteIfSameHashOnMenuItemClick } from 'zoomforth_codesbane_viewer/lib/backbone_history_utils.js';
import {
  handleMenuItemPostClickBehavior,
  setIsInPageSearchDisplayed
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';
import {
  doesOpenInNewTab,
  isExternalLink,
  getTarget,
  getUrl,
} from 'zoomforth_codesbane_viewer/lib/app_actions.js';

import {
  getCurrentSubpage,
  getIsInPageSearchEnabled,
  getLastClickedSubmenuItemId,
  getOrderedVisibleMainMenuItems,
  getSecondaryLogoData,
  getShouldShowSocialLinks,
  getSocialLinks,
  getSubpageIdToOrderedSubmenuItemIdsMap,
  getUseFixedNavLinks,
  getTranslationsAppliedLanguages,
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers';

import {
  setTranslationsCurrentLanguageIso
} from 'zoomforth_codesbane_editor/action_creators/translations.js';

import LanguageSelector from 'zoomforth_component_lib/translations_language_selector_container.jsx';


/*************************************************************************************************/
/*** PROPS ***************************************************************************************/
/*************************************************************************************************/

const PROP_TYPES = {};

const mapStateToProps = (reduxState) => {
  const appliedLanguages = getTranslationsAppliedLanguages(reduxState);
  const currentLanguageIso = getTranslationsCurrentLanguageIso(reduxState);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(reduxState);

  return {
    appliedLanguages,
    currentLanguageIso,
    defaultLanguageIso,
    socialLinks: getSocialLinks(reduxState),
    secondaryLogoData:getSecondaryLogoData(reduxState),
    menuItems: getOrderedVisibleMainMenuItems(reduxState),
    currentSubpage: getCurrentSubpage(reduxState),
    submenuItemsBySubpageId: getSubpageIdToOrderedSubmenuItemIdsMap(reduxState),
    lastClickedSubmenuItemId: getLastClickedSubmenuItemId(reduxState),
    useFixedNavLinks: getUseFixedNavLinks(reduxState),
    shouldShowSocialLinks: getShouldShowSocialLinks(reduxState),
    isInPageSearchEnabled: getIsInPageSearchEnabled(reduxState)
  };
};

const mapDispatchToProps = (dispatch) => ({  
  onInPageSearchOpenerClick: () => { 
    dispatch(setIsInPageSearchDisplayed(true)); 
  },
  onHeaderLogoClick: () => { 
    getRouter().navigateHome({ trigger: true, replace: false }); 
  },
  onMobileMenuItemClick: (menuItem, currentSubpage)=>{
    dispatch(handleMenuItemPostClickBehavior(menuItem, currentSubpage, { shouldScrollTopForPageChange:true }));
  },
  onMobileSubmenuItemClick: (submenuItem)=>{
    getTracker().handleNavMenuItemClick(submenuItem);
    executeMatchedRouteIfSameHashOnMenuItemClick(submenuItem);
  },
  onLanguageChange: (iso)=> {
    dispatch(setTranslationsCurrentLanguageIso(iso));
  }
});

/*************************************************************************************************/
/*** STATE ***************************************************************************************/
/*************************************************************************************************/

const MobileHeader = (props) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const openMenuSidebarHandler = (arg) => {
    if(isNil(arg)){
      setIsMobileMenuOpen(!isMobileMenuOpen)
    } else {
      setIsMobileMenuOpen(arg);
    }
  };

  const menuAndSubMenuMap = getMenuAndSubMenuMap(props, openMenuSidebarHandler);

  const state = {
    isInPageSearchEnabled: props.isInPageSearchEnabled,
    secondaryLogoData: props.secondaryLogoData,
    isMobileMenuOpen,
    socialLinks: props.socialLinks,
    useFixedNavLinks: props.useFixedNavLinks,
    shouldShowSocialLinks: props.shouldShowSocialLinks,
    onHeaderLogoClick: props.onHeaderLogoClick,
    onInPageSearchOpenerClick: props.onInPageSearchOpenerClick,
    openMenuSetter: openMenuSidebarHandler,
    menuAndSubMenuMap,
    appliedLanguages: props.appliedLanguages,
    currentLanguageIso: props.currentLanguageIso,
    defaultLanguageIso: props.defaultLanguageIso,
    onLanguageChange: props.onLanguageChange
  };

  return (<UI state={state}/>);
};

MobileHeader.propTypes = PROP_TYPES;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileHeader);


const getMenuAndSubMenuMap = (props, openMenuSetter) => {
  return props.menuItems.map((menuItem) => {

    const opensInNewWindow = isExternalLink(menuItem.appAction) || doesOpenInNewTab(menuItem.appAction);
    const ariaProp = menuItem.appAction.subpageId === props.currentSubpage.id ? 'page' : null;
    const clickHandler = () => { props.onMobileMenuItemClick(menuItem, props.currentSubpage)};
    const menuItemClasses = `action-nav-link mobile-menu-item-${menuItem.id}`;

    const additionalConfigs = {
      opensInNewWindow,
      ariaProp,
      clickHandler,
      menuItemClasses
    };

    return {
      id: menuItem.id,
      isselected: menuItem.appAction.subpageId === props.currentSubpage.id,
      isPrimaryForSubpage: menuItem.isPrimaryForSubpage,
      anchorProps: getItemAnchorProps(menuItem, additionalConfigs),
      submenuItems: getSubMenuItemList(menuItem, props, openMenuSetter)
    };
  });
};

const getItemAnchorProps = (item, additionalConfigs) => {
  const itemTitle = item.title;
  const target = getTarget(item.appAction);
  const href = getUrl(item.appAction);

  return {
    itemTitle,
    target,
    href,
    ...additionalConfigs
  };
};

const getSubMenuItemList = (menuItem, props, openMenuSetter) => {
  // eslint-disable-next-line security/detect-object-injection
  const getSubMenuItems = (menuItemSubpageId) => props.submenuItemsBySubpageId[menuItemSubpageId];

  let subMenuItems = [];

  if (!isNil(getSubMenuItems(menuItem.appAction.subpageId))) {
    subMenuItems = getSubMenuItems(menuItem.appAction.subpageId).map(
      (submenuItem) => {

        const opensInNewWindow = isExternalLink(menuItem.appAction) || doesOpenInNewTab(menuItem.appAction);
        const menuItemClasses = classNames(
          `action-nav-link mobile-submenu-item-${submenuItem.id}`, 
          {selected: isSubmenuItemSelected(submenuItem, menuItem, props.lastClickedSubmenuItemId)}
        );

        const clickHandler = (e) => {
          if (props.lastClickedSubmenuItemId === submenuItem.id) {e.preventDefault();}
          openMenuSetter();
          props.onMobileSubmenuItemClick(submenuItem);
        };

        const additionalConfigs = {
          opensInNewWindow,
          clickHandler,
          menuItemClasses,
        };

        return {
          menuItemID: menuItem.id,
          submenuItemID: submenuItem.id,
          anchorProps: getItemAnchorProps(submenuItem, additionalConfigs),
        };
      }
    );
  }

  return subMenuItems;
};

/*************************************************************************************************/
/*** UI ******************************************************************************************/
/*************************************************************************************************/

const UI = ({ state }) => (
  <div
    className={classNames('modern-mobile-header-wrapper', {
      'override-default-thumbnail': isNil(state.secondaryLogoData),
    })}
  >
    <MobileHeaderBar state={state} />
    <MobileHeaderBarSpacer state={state} />
    <BurgerMenuWrapper state={state} />
  </div>
);

const MobileHeaderBarSpacer = ({ state }) => (
  state.useFixedNavLinks ?
    <MobileHeaderBar state={state} behaveAsSpacer={true}/>
  :
    null
);

const BurgerMenuWrapper = ({ state }) => {
  return (
    <BurgerMenu
      burgerButtonClassName={'modern-mobile-header'}
      isOpen={state.isMobileMenuOpen}
      width={'100%'}
      right
    >
      {/* hidden for aria purposes - we could use an aria label, but going with this for now */}
      <h2 id='dialog-mobile-nav__label' hidden>Menu</h2>
      <nav
        role='dialog'
        id='new-header-dialog-mobile-nav'
        className='mobile-navigation-view'
        aria-labelledby='dialog-mobile-nav__label'
        aria-modal='true'
      >
        <div className='mobile-search-btn-wrapper'>
          <Button
            className='mobile-menu-closer'
            onClick={() => {state.openMenuSetter();}}
          >
            <div key='1' className='nav-hamburger-close-icon' />
          </Button>

          {state.isInPageSearchEnabled && (
            <InPageSearchOpener onClick={state.onInPageSearchOpenerClick} isEmbeded={true} />
          )}
        </div>
        <Menu state={state} />

        {
          state.shouldShowSocialLinks &&
            <SocialLinks socialLinks={state.socialLinks} />
        }
        
        <LanguageSelector
          currentIso={state.currentLanguageIso}
          defaultLanguageIso={state.defaultLanguageIso}
          appliedLanguages={state.appliedLanguages}
          onLanguageChange={state.onLanguageChange}
        />
      </nav>
    </BurgerMenu>
  )
};

const Menu = ({ state }) => (
  <ul className="new-header-mobile-navigation-menu-list">
    {state.menuAndSubMenuMap.map((menuItem) => (<MenuList key={menuItem.id} props={{menuItem}} />))}
  </ul>
);

const MenuList = ({ props }) => {
  const MenuItem = () => (
    <li
      key={`nav-sec-${props.menuItem.id}`}
      className={classNames( 'menu-item', `mobile-menu-item-${props.menuItem.id}`, { selected: props.menuItem.isselected })}
    >
      <Anchor props={props.menuItem.anchorProps} />
    </li>
  );

  if(props.menuItem.isPrimaryForSubpage){
    return [<MenuItem />].concat(<SubMenuItemsGenerator props={{menuItem: props.menuItem}} />);
  }
  return <MenuItem />;
};

const SubMenuItemsGenerator = ({ props }) =>
  isNil(props.menuItem.submenuItems) ? null : (
    <ul
      key={`nav-sec-${props.menuItem.id}-subsec`}
      className="new-header-mobile-navigation-menu-list"
    >
      {map(props.menuItem.submenuItems, (submenuItem) => (<SubMenuItem key={submenuItem.id} props={{submenuItem}} />))}
    </ul>
  );

const SubMenuItem = ({ props }) => (
  <li
    key={`nav-sec-${props.submenuItem.id}-subsec-${props.submenuItem.id}`}
    className="menu-item is-subsection"
  >
    <Anchor props={props.submenuItem.anchorProps} />
  </li>
);

const Anchor = ({ props }) => (
  <a
    aria-current={props.ariaProp}
    onClick={props.clickHandler}
    target={props.target}
    href={props.href}
    className={props.menuItemClasses}
  >
    {props.itemTitle}{' '}
    {props.opensInNewWindow && <span>(Opens in a new window)</span>}
  </a>
);

const MobileHeaderBar = ({ state, behaveAsSpacer }) => (
  <div className={classNames('modern-mobile-header',  {
    'fixed-modern-header-spacer': behaveAsSpacer
  })}
  tabIndex={behaveAsSpacer ? -1 : null}
  >
    <a href="" className="header-thumbnail" onClick={state.onHeaderLogoClick}>
      <VisuallyHiddenSpan>Return home</VisuallyHiddenSpan>
    </a>
    {!isEmpty(state.secondaryLogoData) && (
      <SecondaryLogo secondaryLogoData={state.secondaryLogoData} />
    )}
    <Button
      className="mobile-menu-opener"
      onClick={() => {state.openMenuSetter(true);}}
    >
      <HamburguerOpenIcon />
    </Button>
  </div>
);

const HamburguerOpenIcon = () => (
  <div key="1" className="nav-hamburger-open-icon">
    <div className="bar"></div>
    <div className="bar"></div>
    <div className="bar"></div>
  </div>
);

